import { Component, EventEmitter, Input, Output } from '@angular/core';

export type PaginatedListItem<T = unknown> = {
    title: string;
    isDisabled?: boolean;
    isSelected?: boolean;
    payload: T;
};

/**
 * Creates a list with a paginator in the footer, so it can be paginated insted of being scrolled
 */
@Component({
    selector: 'cw-paginated-list',
    templateUrl: './paginated-list.component.html',
    styleUrls: ['./paginated-list.component.scss'],
    standalone: false,
})
export class PaginatedListComponent {
    /** The items shown per page */
    @Input() pageSize = 4;
    /** List of items to show in the list */
    @Input() items: PaginatedListItem[] = [];
    /** Set the page number */
    @Input() currentPage = 1;
    /** Enable or disable the full component */
    @Input() disabled = false;
    /** Emits the list of selected items on selection change */
    @Output() selectionChanged = new EventEmitter<PaginatedListItem[]>();

    onChangePage(newPage: number): void {
        if (this.currentPage !== newPage) {
            this.currentPage = newPage;
        }
    }

    /**
     * Toggle selection on item if item or list are not disabled
     * @param item
     */
    toggleSelect(item: PaginatedListItem): void {
        if (item.isDisabled || this.disabled) {
            return;
        }

        item.isSelected = !item.isSelected;
        this.selectionChanged.emit(this.selectedItems);
    }

    /**
     * Get the list of selected items
     */
    get selectedItems(): PaginatedListItem[] {
        return this.items.filter((item) => item.isSelected);
    }

    /**
     * Get visible items
     */
    get pagedItems(): PaginatedListItem[] {
        if (this.currentPage === 0 && this.items.length) {
            this.currentPage = 1;
        }
        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;
        return this.items.slice(start, end);
    }
}
